module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DFsG1H/tc-custom/9781626810426.jpg?1696548592047",
      "alt": "This image is the cover for the book Lady of Fire, The Fire Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lady of Fire, The Fire Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("First in the epic medieval romance series: A passionate story of intrigue, chivalry, and forbidden love from the author of "), _c('i', [_vm._v("Fire and Steel")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Beautiful Eleanor of Nantes is pursued by many great noblemen, including the evil Robert of Belesme and charming Prince Henry, son of William the Conqueror. But it is the dashing Roger FitzGilbert, born a bastard with no title to his name, who sweeps her off her feet. Their love may be forbidden, but their passion is undeniable . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Anita Mills makes a phenomenal debut . . . Splendid . . . A highly romantic, action-packed tale of enduring love.” —"), _c('i', [_vm._v("Romantic Times")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “For medieval romance lovers, this one should be on your keeper shelf . . . The story is rich in historic details with an intricately woven plot, fast-moving dialog and action. It’s a page-turner and so well written.” —"), _c('i', [_vm._v("Historical Romance Review with Regan Walker")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anita Mills\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0